
import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { ContractBriefReportComponent } from '../pages/contract-brief-report/contract-brief-report.component';
import { FormBuilder } from '@angular/forms';
import { AdvertisementDetailsComponent } from '../pages/advertisement-details/advertisement-details.component';
import { ToWords } from 'to-words';
import { NgxPrintDirective } from 'ngx-print';
import { BookSellerRegistrationComponent } from '../pages/book-seller-registration/book-seller-registration.component';

@Component({
  selector: 'app-creadit-receipt-component',
  templateUrl: './creadit-receipt-component.component.html',
  styleUrls: ['./creadit-receipt-component.component.scss']
})
export class CreaditReceiptComponentComponent implements OnInit {
  public globalId: string = '';
  totalinWords: String;
  toWords: any;
  credit_type: any;
  remark: any;
  invoice_amt: any;
  credit_remark: any;
  remaining_amt: any;
  unpaid_amt: any;
  constructor(private dialogRef: MatDialogRef<CreaditReceiptComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,private fb: FormBuilder,public activeModal: MatDialogRef<BookSellerRegistrationComponent>,
    @Inject(MAT_DIALOG_DATA) public data1: any
  )
   { }
name:any
add:any
mobile:any;
invoicenum:any
invoicedate:any
CreitVC:any
jama:any
  ngOnInit(): void {
    
    // data: {
    //   name: data[0].name,
    //   add : data[0].address,
    //   mobile : data[0].mobile,
    //   invoicenum : data[0].invoice_no,
    //   invoicedate : data[0].voc_date,
    //   jama : data[0].credit_amt,
     
    // },
    debugger
      this.name= this.data['name']
        this.add= this.data['add']
        this.mobile= this.data['mobile']
        this.invoicenum= this.data['invoicenum']
        this.invoicedate= this.data['invoicedate']
        this.jama=this.data['jama']
        this.unpaid_amt=this.data['unpaid_amt']
        this.invoice_amt=this.data['invoice_amt']
        this.remaining_amt=this.data['remaining_amt']
        this.credit_type= this.data['credit_type']
        this.credit_remark= this.data['credit_remark']
        this.CreitVC=this.data['cr_voucher']

        console.log(this.data, "gst data")


        this.toWords = new ToWords();
        this.totalinWords = this.toWords.convert(this.data['jama'], {
          currency: true,
        });
       
   
  }
  // print(): void {
  //   // Call ngxPrint directive to print the specified section
  //   NgxPrintDirective.print({printSectionId: 'print-section'});
  // }

}

